import React, { ReactNode, useContext } from "react";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";

import "./styles/index.scss"; // Import CSS file for styling
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PageThemeContext from "../../../Contexts/pageThemeContext";
import { THEME } from "../../../theme";

interface FlyoverProps {
  isOpen: boolean;
  closeMenu: () => void;
  children: ReactNode;
}

const Flyover: React.FC<FlyoverProps> = ({ isOpen, closeMenu, children }) => {
  const theme = useContext(PageThemeContext);
  const navigate = useNavigate();

  const flyoverContent = (
    <div className={`flyover ${isOpen ? "open" : ""}`}>
      <Container className="overlay">
        <Container
          className="headerLogoContainer"
          onClick={() => navigate("/")}
        >
          <img
            src={
              theme === THEME.DARK
                ? "https://kivunova.s3.us-east-1.amazonaws.com/Kivu-Nova-ligh.jpg"
                : "https://kivunova.s3.us-east-1.amazonaws.com/kivu-nova-dark.png"
            }
            alt="Logo"
            width="100%"
            height="100%"
          />
        </Container>
        <Container
          sx={{
            width: "fit-content",
            margin: "0"
          }}
        >
          <CloseIcon fontSize="large" onClick={closeMenu} />
        </Container>
      </Container>
      <Container className="flyover-content">{children}</Container>
    </div>
  );

  return createPortal(flyoverContent, document.body);
};

export default Flyover;
